import { FieldLogVisitBackButton } from '@/features/field-log/components/FieldLogVisitBackButton';
import { EditorHeader } from '@/shared/components/EditorHeader';
import { Skeleton } from '@/shared/components/ui/skeleton';

/** Matches the shape of the visit board while its detail loads. */
export function FieldLogVisitPendingState() {
  return (
    <div className="flex min-h-svh flex-col">
      <EditorHeader
        start={
          <div className="flex min-w-0 items-center gap-2 sm:gap-3">
            <FieldLogVisitBackButton />
            <Skeleton className="h-4 w-56" />
          </div>
        }
      />
      <div className="flex min-h-0 flex-1 flex-col gap-5 p-4 md:p-6">
        <Skeleton className="h-11 w-full" />
        <Skeleton className="min-h-40 flex-1" />
      </div>
    </div>
  );
}
